// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaEnvelope } from "react-icons/fa";
import logo from "../assets/images/ssspowerlifting_logo.png";
import "./Footer.css";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/#about", label: "About" },
  { to: "/full-gallery", label: "Gallery" },
  { to: "/meet-recaps", label: "Meet Recaps" },
  { to: "/#contact", label: "Apply / Contact" },
];

const Footer = () => (
  <footer className="footer">
    <div className="footer__inner">
      <div className="footer__top">
        <div className="footer__brand">
          <Link
            to="/"
            className="footer__logo-link"
            aria-label="SSS Powerlifting home"
          >
            <img src={logo} alt="" className="footer__logo" />
            <span className="footer__wordmark">SSS Powerlifting</span>
          </Link>
          <p className="footer__tagline">Remote powerlifting coaching</p>
          <div className="footer__social">
            <a
              href="https://www.instagram.com/ssspowerlifting?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="SSS Powerlifting on Instagram"
              className="footer__icon"
            >
              <FaInstagram size={20} />
            </a>
            <a
              href="mailto:ssspowerlifting@gmail.com"
              aria-label="Email SSS Powerlifting"
              className="footer__icon"
            >
              <FaEnvelope size={20} />
            </a>
          </div>
        </div>

        <nav className="footer__nav" aria-label="Footer">
          {navLinks.map((link) => (
            <Link key={link.to} to={link.to} className="footer__nav-link">
              {link.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="footer__divider" />

      <div className="footer__legal">
        <p>
          © {new Date().getFullYear()} Saillant Strength Systems Powerlifting
        </p>
        <p>Website by Michael Lebreck</p>
      </div>
    </div>
  </footer>
);

export default Footer;
